var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageMyProfileLocationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.079 31.0015L14.2508 29.681C15.5806 28.1582 16.7766 26.7133 17.8407 25.339L18.7191 24.1802C22.387 19.2383 24.2218 15.316 24.2218 12.417C24.2218 6.22903 19.2336 1.21289 13.079 1.21289C6.92441 1.21289 1.93613 6.22903 1.93613 12.417C1.93613 15.316 3.77098 19.2383 7.43884 24.1802L8.31727 25.339C9.83537 27.2842 11.4237 29.1717 13.079 31.0015Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.079 16.9986C15.6432 16.9986 17.7218 14.9199 17.7218 12.3557C17.7218 9.79157 15.6432 7.71289 13.079 7.71289C10.5148 7.71289 8.43613 9.79157 8.43613 12.3557C8.43613 14.9199 10.5148 16.9986 13.079 16.9986Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMyProfileLocationLogo);
export default __webpack_public_path__ + "static/media/manage_my_profile_location_logo.bda58e7fa64f1f585fb2e6693a161078.svg";
export { ForwardRef as ReactComponent };